export default __webpack_public_path__ + "static/media/purple-points.69b12346.svg";